import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/internet-tv.png'
import _imports_1 from '../assets/channels.png'
import _imports_2 from '../assets/tvsmart.png'


const _withScopeId = n => (_pushScopeId("data-v-31ccebd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-6" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Watch premium OTT apps")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_jt_tv_plans = _resolveComponent("jt-tv-plans")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_jt_internet_tv_features = _resolveComponent("jt-internet-tv-features")!
  const _component_jt_need_guidance = _resolveComponent("jt-need-guidance")!
  const _component_jt_footer = _resolveComponent("jt-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, { class: "mt-3 mx-8" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, { src: _imports_0 })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_1,
    _createVNode(_component_v_row, { class: "mt-3 mx-8" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, { src: _imports_1 })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_jt_tv_plans),
    _createVNode(_component_v_row, { class: "mt-10" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { class: "d-flex justify-center image-holder" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, { src: _imports_2 }),
            _createVNode(_component_v_btn, {
              class: "btn-primary on-image getnow",
              style: {}
            }, {
              default: _withCtx(() => [
                _createTextVNode("Get Now")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_jt_internet_tv_features),
    _createVNode(_component_jt_need_guidance),
    _createVNode(_component_jt_footer)
  ], 64))
}